export default [
  {
    path: '/ai-tags',
    component: () => import('./views/Index'),
    name: 'ai_tag',
    redirect: { name: 'ai_tag-list' },
    children: [
      {
        path: '',
        name: 'ai_tag-list',
        component: () => import('./views/List'),
        meta: {
          resource: 'content',
        },
      },
      {
        path: ':id',
        name: 'ai_tag-detail',
        component: () => import('./views/Detail'),
        meta: {
          resource: 'content',
        },
      },
    ],
  },
]
